import { Col, Row } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { Card } from 'src/components/Card/Card';
import { DataView } from 'src/components/DataView/DataView';
import { ResourceNameView } from 'src/components/ResourceNameView/ResourceNameView';
import { PartnerDto, ProductDto } from 'src/generated-api-client';
import { ProductOfferingTypeResourceStore } from 'src/stores/Resources/ProductOfferingTypeResourceStore';
import styled from 'styled-components';

type ProductInformationTabProps = {
    partner: PartnerDto | null;
};

export const ProductInformationTab = observer(
    ({ partner }: ProductInformationTabProps) => {
        return (
            <div>
                {partner?.products?.map((product) => (
                    <ProductInformationCard
                        key={product.id}
                        product={product}
                    />
                ))}
            </div>
        );
    },
);

type ProductInformationCardProps = {
    product: ProductDto;
};
const ProductInformationCard = ({ product }: ProductInformationCardProps) => {
    return (
        <Card title={t('Product.Information', 'Product info')}>
            <Row gutter={[16, 16]}>
                <Col span={12}>
                    <DataView
                        label={t('Product.ID', 'Product ID')}
                        value={product.number}
                    />
                </Col>

                <Col span={12}>
                    <DataView
                        label={t('Product.Name', 'Product name')}
                        value={product?.name}
                    />
                </Col>

                <Col span={12}>
                    <StyledPartnerLink
                        label={t(
                            'Product.PartnerSystemLink',
                            'Partner system link',
                        )}
                        value={product?.partnerSystemLink}
                    />
                </Col>

                <Col span={12}>
                    <ResourceNameView
                        label={t('Product.OfferingTypes', 'Types of offerings')}
                        resourceStore={ProductOfferingTypeResourceStore}
                        value={product?.offeringTypes}
                    />
                </Col>

                <Col span={12}>
                    <DataView
                        label={t('Product.MinAmount', 'Min loan amount')}
                        formatValue="currency-sar"
                        value={product?.minAmount}
                    />
                </Col>

                <Col span={12}>
                    <DataView
                        label={t('Product.MaxAmount', 'Max loan amount')}
                        formatValue="currency-sar"
                        value={product?.maxAmount}
                    />
                </Col>

                <Col span={12}>
                    <DataView
                        label={t('Product.MinTerms', 'Min term (months)')}
                        value={product?.minTerms}
                    />
                </Col>

                <Col span={12}>
                    <DataView
                        label={t('Product.MaxTerms', 'Max term (months)')}
                        value={product?.maxTerms}
                    />
                </Col>

                <Col span={12}>
                    <DataView
                        label={t(
                            'Product.MinMurabahaRatePct',
                            'Min murabaha rate',
                        )}
                        formatValue="percent"
                        value={product?.minMurabahaRatePct}
                    />
                </Col>

                <Col span={12}>
                    <DataView
                        label={t(
                            'Product.MaxMurabahaRatePct',
                            'Max murabaha rate ',
                        )}
                        formatValue="percent"
                        value={product?.maxMurabahaRatePct}
                    />
                </Col>
            </Row>
        </Card>
    );
};

const StyledPartnerLink = styled(DataView)`
    .data-view__value {
        white-space: pre-wrap;
        word-break: break-word;
    }
`;
